import React from 'react'
import GamificationPage from '../GamificationPage';

 function Gamification() {
  return (
    <>
    <GamificationPage />
    </>
  )
}
export default Gamification;